{
  "user": {
    "profile": "Profile",
    "logout": "Logout"
  },
  "changeRequest": {
    "title": "Change requests",
    "assignedToMe": "Assigned to me"
  },
  "search": {
    "placeholder": "Search",
    "nothingFound": "Nothing found",
    "loading": "Searching...",
    "mode": {
      "both": "Search and select",
      "select": "Select",
      "search": "Search"
    },
    "hint": {
      "title": "Shortcuts",
      "drill": "next",
      "search": "search",
      "open": "go",
      "back": "back"
    },
    "groups": {
      "navigation": "Navigation",
      "dashboards": "Dashboards",
      "attributes": "Attributes"
    },
    "sections": {
      "recent": "Recent",
      "results": "Results"
    },
    "recent": {
      "remove": "Remove"
    }
  },
  "notification": {
    "title": "Notifications",
    "status": {
      "new": "New",
      "viewed": "Viewed"
    },
    "checkViewed": "Check as viewed",
    "viewed": "Viewed",
    "notificationLink": "Notification manager"
  }
}